module.exports = __webpack_public_path__ + "videogular.d4f9c9f4aca582e94b2a.svg";


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/lednube/node_modules/videogular2/fonts/videogular.svg?hj1wei
// module id = ../../../../videogular2/fonts/videogular.svg?hj1wei
// module chunks = styles